module.exports = __webpack_public_path__ + "web_static/img/yellowzigzag.783c22c1.gif";